import { ChangeDetectorRef, Component, ElementRef, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { OneWebComponentsAngularModule } from '@one/angular';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { QnSbnDataServiceService } from '../../services/qn-sbn-data-service.service';
import { Router } from '@angular/router';
import { AppUtils } from '../../utlis/app-utils';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { NotificationAuditTrailComponent } from '../notification-audit-trail/notification-audit-trail.component';
import { ViewReminderDetailsComponent } from '../view-reminder-details/view-reminder-details.component';
import { SnackbarService } from '../../services/snackbar.service';
import { LsoAcknowledgementComponent } from '../lso-acknowledgement/lso-acknowledgement.component';

@Component({
  selector: 'dl-contact-details',
  standalone: true,
  imports: [OneWebComponentsAngularModule,CommonModule,LsoAcknowledgementComponent,ViewReminderDetailsComponent,ReactiveFormsModule,FormsModule,NotificationAuditTrailComponent],
  templateUrl: './contact-details.component.html',
  styleUrl: './contact-details.component.scss'
})
export class ContactDetailsComponent {

  public breadcrumbs = [];
  customerDataObj: any;
  Status:any;
  public testdata: any[];
  CustomerId: any;
  customerTitle: any;
  isEditDisabled: boolean = false;
  isReminderDisabled: boolean = true;
  showEditControls: boolean = false;
  isResendEnabled:boolean = false;
  public visibleView: boolean = false;
  public customerData:any;
  public customerNotificationData: any;
  public recepientForm: FormGroup;
  public CustomerDetails:any;
  public NotificationId:any;
  public userFileSize = { size: 0, type: '' };
  public userPermission: any;
  public allReminderSent: any;
  public ackFile: any = [];
  public ackComment: any;
  public ackFileName: any;
  public ackFileSize: any;
  public isSetCom: boolean = false;
  public isSetCancelled: boolean =false;
  public isNotiStat: boolean =false;
  public contactNotificationId: any;
  public accDataObj: any;
  public isDisabled: boolean =false;
  public visibleAuditTrail: boolean = false;
  public visibleReminder: boolean = false;
  public acknowledgementVisible:boolean = false;
  inputData: any;
  data: { notificationData: any; customerData: any; };

  
  constructor(
    public appUtils: AppUtils,
    private fb: FormBuilder,
    private _cdr: ChangeDetectorRef,
    private router: Router,
    private snackBarNotification: SnackbarService,
    private qnsbnservice :QnSbnService,
    // private readonly dialog: MatDialog,
    public _QnSbnService:QnSbnService,
    public _QnSbnDataService:QnSbnDataServiceService,
  ) {}

  // public sort: MatSort;
  exporter: ElementRef<any>;
  notificationDetails: any;
  selectedRecepientColumns: any;
  contactDetails: any;
  notificationLabel: any;
  contactDataDetails: any;
  public displayedColumns: string[];
  public dataSource = [];
  public selection = [];
  public selectedRow: any;
  public isAddRecipientDisabled: boolean;
  public isAfoBtnDisabled: boolean;
  public isAfoBtnExpanded: boolean;
  public filteredStatusList: any;
  public auditTrailDatafromAPI: any;
  public notificationId: any;

  public ngOnChanges(changes: SimpleChanges): void {
    throw new Error('Method not implemented.');
  }
  public isAllSelected($event: any): boolean {
    throw new Error('Method not implemented.');
  }
  public masterToggle($event: any): void {
    throw new Error('Method not implemented.');
  }
  public handleChecked(row: any): void {
    throw new Error('Method not implemented.');
  }
  public ndAddRecepients(): void {
    throw new Error('Method not implemented.');
  }
  
  public ngOnInit(): void {
    this.userPermission = this.qnsbnservice.getUserData();
    this.customerDataObj = history.state;
    this.accDataObj =  this.customerDataObj.accDataObj
    this.customerData = this.customerDataObj.customerDetails.customerData;
    this.isSetCom = this.customerDataObj.customerDetails.isSetCom;
    this.isSetCancelled = this.customerDataObj.customerDetails.isSetCancelled;
    this.isNotiStat = this.customerDataObj.customerDetails.notificationStatus;
    this.customerNotificationData = this.customerDataObj.customerDetails.notificationData[0];
    this.NotificationId = this.customerData.NotificationId;
    this.contactNotificationId = this.customerData.ContactNotificationId
    this.CustomerId = this.customerData.CustomerId;
    this.customerTitle = this.customerData.CustomerContactName;
    this.allReminderSent = this.getAllReminderSent(this.customerData.CustomerReminderDetails);
    this.breadcrumbs = [
      {
        label: 'Notifications'
      },
      {
        label: this.customerData.LocalId
      },
      {
        label: this.customerData.CustomerName + " " + this.customerData.CustomerId
      },
      {
        label: this.customerTitle
      }
    ];
    if (this.customerData.Status === "Completed" || this.customerData.Status === "Feedback Received") {
      this.isEditDisabled = true;
    }
    if (this.customerData.Status !== "Feedback Received" && this.customerData.Status !== "Completed" && this.customerNotificationData.Status !== "Superseded") {
      this.isResendEnabled = true;
    }
    if (this.customerData.Status === "Delivery Failed") {
      this.isDisabled = true;
    }
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ .]{2,30}$/;
    const sourceRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ ._\-&0-9,']{2,30}$/;
    this.recepientForm = this.fb.group({
      recepientSource: [null, [Validators.required, Validators.pattern(sourceRegex)]],
      // recepientName: [null, [Validators.required, Validators.pattern(nameRegex)]],
      recepientName: [null, [Validators.required]],
      recepientEmail: [null, [Validators.required, Validators.pattern(emailRegex)]], // Validators.email
    });
    if(this.customerData.CustomerAttachment){
      this.ackComment = this.customerData.CustomerAttachment.Comments;
      this.ackFileName = this.customerData.CustomerAttachment.Filename;
      this.ackFileSize = this.customerData.CustomerAttachment.FileSize;
    }else{
      this.ackComment = '';
      this.ackFileName = '';
      this.ackFileSize = '';
    } 
}

  editRecepientDetails() {
    this.CustomerDetails = {
      "ContactNotificationId":this.customerData.ContactNotificationId,
      "CustomerContactEmail":this.recepientForm.value.recepientEmail,
      "NotificationId": this.customerData.NotificationId,
      "CustomerId": this.customerData.CustomerId,
      "CustomerName": this.customerData.CustomerName,
      "DataSource":this.recepientForm.value.recepientSource,
      "CustomerContactName": this.recepientForm.value.recepientName
    };

    this.qnsbnservice.EditCustomerData(this.CustomerDetails).subscribe(
      (response: HttpResponse<any>) => {
        this.customerData.DataSource = this.recepientForm.value.recepientSource;
        this.customerData.CustomerContactName = this.recepientForm.value.recepientName;
        this.customerData.CustomerContactEmail = this.recepientForm.value.recepientEmail;
        this.closeEditForm();
        this._cdr.detectChanges();
        this.snackBarNotification.snackBarMessage('positive', 'Contact data updated Successfully');
      },
      (error: HttpErrorResponse) => {
        this.qnsbnservice.httpErrorHandler(error, 'Contact data updation Failed.');
      }
    );
    
  }
  openEditForm() {
    this.showEditControls = true;
    this.recepientForm.controls['recepientSource'].setValue(this.customerData.DataSource);
    this.recepientForm.controls['recepientName'].setValue(this.customerData.CustomerContactName);
    this.recepientForm.controls['recepientEmail'].setValue(this.customerData.CustomerContactEmail);
  }
  closeEditForm() {
    this.showEditControls = false;
  }

 public viewReminders(): void {
  this.data = { 
    notificationData: this.customerNotificationData, 
    customerData: this.customerData
  };
  this.visibleView = true;
}

  public bytesCalculation(bytes: number, decimals: number = 2): any {
    if (bytes === 0) {
      this.userFileSize.size = 0;
      this.userFileSize.type = '';
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    this.userFileSize.size = 0;
    this.userFileSize.type = '';

    this.userFileSize.size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    this.userFileSize.type = sizes[i];
    return this.userFileSize;
  }

  public formatBytes(bytes: number, decimals: number = 2): string {
    this.bytesCalculation(bytes, decimals);
    return this.userFileSize.size + ' ' + this.userFileSize.type;
  }

  public getAllReminderSent(reminderDetails: any) {
    // [{ReminderSendStatus: "Not Sent", ReminderDueDate: "02-Feb-2022", ReminderId: 0}]
    const reminderSents = [];
    if (reminderDetails && reminderDetails.length > 0) {
      reminderDetails.forEach(reminder => {
        if (reminder.ReminderSendStatus === 'Delivered') {
          let reminderSentDate = reminder.ReminderSendDate ? reminder.ReminderSendDate : reminder.ReminderDeliveryFailedDate ? reminder.ReminderDeliveryFailedDate : reminder.ReminderDueDate;
          // reminderSents.push(this.appUtils.formatDateWithTime(reminderSentDate));
        }
      });
    } else {
      reminderSents.push('');
    }
    return reminderSents;
  }

  public displayStatus(status) {
    const statusText = status ? status : 'Pending';
    return statusText;
  }

  public downloadDocument(globalNotificationId: string, fileExtension: string) {
    this.qnsbnservice.downloadPiosDocumentApi(globalNotificationId, fileExtension);
  }
  
  public downloadAttachment(fileName: string, notificationId: string) {
    this.qnsbnservice.downloadLocalAttachmentApi(fileName, notificationId);
  }
  
  public downloadLSOAttachment(fileName: string, notificationId: string, contactNotificationId: string) {
    this.qnsbnservice.downloadLSOAttachmentApi(fileName, notificationId, contactNotificationId);
  }

  public onResendNotification(event){
    const resendApi = {
      NotificationId : this.NotificationId,
      ContactNotificationIds:  [this.customerData.ContactNotificationId]
    }
    const resendJson= JSON.stringify(resendApi);
    this.qnsbnservice.postResendNotifications(resendJson).subscribe(
      (data:any) => {
        this.snackBarNotification.snackBarMessage('positive', 'Notification sent successfully');
        this.gotoAccountDetailsPage(event);
      },
      (error: HttpErrorResponse) => {
        this.qnsbnservice.httpErrorHandler(error, 'Email id is either not verified or wrong. Please correct and try again later.');
      }
    );
  }

  public downloadEmailEvidence(filename: string) {
    let  notificationId: string = this.customerData.NotificationId;
    let CustomerContactEmail: string = this.customerData.CustomerContactEmail;
    this.qnsbnservice.downloadEmailEvidenceApi(notificationId, filename, CustomerContactEmail);
  }

  public lsoAcknowledgement(): void {
  this.acknowledgementVisible = true;
}

  // Account name is stored on CustomerName for the contact's parent account
  public get lsoAcknowledgementStatement(): string {
    const accountName = this.customerData?.CustomerName || '';
    return `Acknowledged by the LSO on behalf of ${accountName}`;
  }

public onAcknowledgementClosed(result: any) {
  this.acknowledgementVisible = false;

  if (!result) {
    return;
  }

  this.ackComment = result.ackComment;
  this.ackFile = result.ackFile;

  if (this.ackFile && this.ackFile.length > 0 && this.ackFile[0]) {
    this.ackFileName = this.ackFile[0].name;
    this.ackFileSize = this.formatBytes(this.ackFile[0].size);
  }

  this.ackFileApiCall(this.ackFile,result);
}


  public ackFileApiCall(fileData,event): void {
    if(fileData.length > 0){
      for(let f=0;f<=(fileData.length-1);f++){
        if(fileData[f].uploadFile) {
          const feedbackApi = {
            customerId: this.customerData.CustomerId,
            email: this.customerData.CustomerContactEmail,
            notificationId: this.customerData.NotificationId,
            comments: this.ackComment,
            fileName: fileData[f].name,
            fileSize: this.formatBytes(fileData[f].size),
            contactNotificationId: this.customerData.ContactNotificationId
          }
          const feedbackApiJson = JSON.stringify(feedbackApi);
          this._QnSbnService.fileAckSaveOnS3(fileData[f], this.customerData.ContactNotificationId,this.customerData.NotificationId).subscribe((res) =>{
            this._QnSbnService.feedbackApi(feedbackApiJson).subscribe((res) => {

              this.gotoNotificationDetailsPage(event);
              this.snackBarNotification.snackBarMessage('positive', 'Acknowledgement successfully created');
            },
            (err)=>{
              this.snackBarNotification.snackBarMessage('alarm', 'Please try again later');
            });
          });
        }
      }       
    }else{
      const feedbackApi = {
        customerId: this.customerData.CustomerId,
        email: this.customerData.CustomerContactEmail,
        notificationId: this.customerData.NotificationId,
        comments: this.ackComment,
        contactNotificationId: this.customerData.ContactNotificationId
      }
      const feedbackApiJson = JSON.stringify(feedbackApi);
      this._QnSbnService.feedbackApi(feedbackApiJson).subscribe((res) => {
        this.gotoNotificationDetailsPage(event);
        this.snackBarNotification.snackBarMessage('positive', 'Acknowledgement successfully created');
      },
      (err)=>{
        this.snackBarNotification.snackBarMessage('alarm', 'Please try again later');
        
      });
    }
  }

  public gotoAccountDetailsPage(event) {
     event.preventDefault();
    event.stopPropagation();
    let rowData = {
      customerData: this.accDataObj,
      isSetCom: this.isSetCom,
      isSetCancelled: this.isSetCancelled,
      notificationStatus:  this.isNotiStat,
      notificationData: this.customerNotificationData
    };
    this.qnsbnservice.getContactList(this.accDataObj.AccountNotificationId).subscribe(
      res =>{
        
        this.router.navigate(['/account-details'], { state: { customerDetails: rowData, notificationDataObj: res.body } });
      },
      err =>{
        this.snackBarNotification.snackBarMessage('alarm', 'Failed to fetch Contact Data');
      }
    );
  }

  public gotoNotificationDetailsPage(event){
     event.preventDefault();
    event.stopPropagation();
    this.qnsbnservice.getNotificationContactDetails(this.NotificationId).subscribe(
      (data:any) => {
        this._QnSbnService.getAccountList(this.NotificationId).subscribe(
          res =>{
           
            this.router.navigate(['/notification-details'], { state: { notificationData: this.customerNotificationData, contactData: data, accountDataObj: res.body } });
          },
          (err: HttpErrorResponse) => {
            this._QnSbnService.httpErrorHandler(err, 'Could not fetch Account Data');
          }
        );
      },
      (error: HttpErrorResponse) => {
        this.qnsbnservice.httpErrorHandler(error, 'Could not fetch contact details.');
        this.router.navigate(['/notification-details'], { state: { notificationData: this.customerNotificationData, contactData: [], accountDataObj: [] } });
      }
    );
  }

  public gotoNotificationPage(event){
      event.preventDefault(); 
    event.stopPropagation();
    this.router.navigate(['/notification']);
  }

  public viewAuditTrail(){
    this.contactNotificationId = this.customerData.ContactNotificationId;
    this.qnsbnservice.getContactNotificationAuditTrailList(this.contactNotificationId).subscribe(
      res =>{
        this.auditTrailDatafromAPI=res;
        this.visibleAuditTrail = true;
        this.inputData = this.auditTrailDatafromAPI;
        
      },
      err =>{
        this.snackBarNotification.snackBarMessage('alarm', 'Failed to fetch Audit Trail Data');
      }
    );
  }
}
